/**
 * Skyyrizon Collection — client-side price filters + sort + quick-add.
 *
 * Filters: All / Under $25 / Under $50 / Under $100 (Best Sellers is a link that
 * sets ?sort_by=best-selling and reloads — server-side sort).
 *
 * Sort dropdown: changes URL with ?sort_by=X — Shopify handles the sort server-side.
 */
(function () {
  'use strict';

  var SECTIONS_FOR_ADD = '?sections=cart-icon-bubble,cart-live-region-text';

  function initCollection() {
    var root = document.querySelector('[data-sky-collection]');
    if (!root) return;

    var grid = root.querySelector('[data-sky-collection-grid]');
    var filterBtns = root.querySelectorAll('[data-sky-filter]');
    var filterClearBtn = root.querySelector('[data-sky-filter-clear]');
    var emptyFilterEl = root.querySelector('[data-sky-collection-empty-filter]');
    var sortSelect = root.querySelector('[data-sky-sort]');
    var countEl = root.querySelector('[data-sky-collection-count]');

    // ── Client-side filter by price ──────────────────

    function applyFilter(filter) {
      if (!grid) return;
      var cards = grid.querySelectorAll('[data-sky-product-card]');
      var threshold = null;
      if (filter === 'under-25') threshold = 2500;
      else if (filter === 'under-50') threshold = 5000;
      else if (filter === 'under-100') threshold = 10000;

      var visible = 0;
      cards.forEach(function (card) {
        var price = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
        var show = (threshold === null) || (price <= threshold);
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });

      if (emptyFilterEl) emptyFilterEl.hidden = visible > 0;

      if (countEl) {
        var word = visible === 1 ? 'product' : 'products';
        var suffix = threshold === null ? '' : ' matching';
        countEl.textContent = visible + ' ' + word + suffix;
      }
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-sky-filter');
        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        // Also clear active state on Best Sellers link if user clicks a price filter
        var bestLink = root.querySelector('.sky-collection__pill--link');
        if (bestLink) bestLink.classList.remove('is-active');

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        applyFilter(filter);
      });
    });

    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', function () {
        var allBtn = root.querySelector('[data-sky-filter="all"]');
        if (allBtn) allBtn.click();
      });
    }

    // ── Sort dropdown → reload with ?sort_by ─────────

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var val = sortSelect.value;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        window.location.href = url.toString();
      });
    }

    // ── Add to Cart (per card) ───────────────────────

    var addForms = root.querySelectorAll('[data-sky-pcard-add-form]');
    addForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;

        var labelDefault = btn.querySelector('[data-sky-pcard-btn-default]');
        var labelLoading = btn.querySelector('[data-sky-pcard-btn-loading]');
        var labelDone = btn.querySelector('[data-sky-pcard-btn-done]');

        if (labelDefault) labelDefault.hidden = true;
        if (labelLoading) labelLoading.hidden = false;
        btn.disabled = true;

        var routes = (window.Shopify && window.Shopify.routes) || {};
        var addUrl = (routes.cart_add_url || '/cart/add.js') + SECTIONS_FOR_ADD;
        var formData = new FormData(form);

        fetch(addUrl, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            if (text) { try { data = JSON.parse(text); } catch (e) { data = { description: text }; } }
            if (!res.ok) throw data;
            return data;
          });
        }).then(function (cartResponse) {
          if (labelLoading) labelLoading.hidden = true;
          if (labelDone) labelDone.hidden = false;
          updateCartIconFromResponse(cartResponse);
          setTimeout(function () {
            if (labelDone) labelDone.hidden = true;
            if (labelDefault) labelDefault.hidden = false;
            btn.disabled = false;
          }, 1600);
        }).catch(function (err) {
          if (labelLoading) labelLoading.hidden = true;
          if (labelDefault) labelDefault.hidden = false;
          btn.disabled = false;
          var msg = (err && err.description) || (err && err.message) || 'Could not add.';
          window.alert(msg);
        });
      });
    });
  }

  // ── Cart icon update via Section Rendering API ───

  function replaceSectionOnPage(sectionKey, newHtml) {
    if (!newHtml) return;
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(newHtml, 'text/html');
      var newSection = doc.querySelector('#shopify-section-' + sectionKey);
      var currentSection = document.getElementById('shopify-section-' + sectionKey);
      if (newSection && currentSection) { currentSection.replaceWith(newSection); return; }
      var currentBubble = document.querySelector('.cart-count-bubble');
      var newBubble = doc.querySelector('.cart-count-bubble');
      if (currentBubble && newBubble) currentBubble.replaceWith(newBubble);
    } catch (e) { /* non-fatal */ }
  }

  function updateCartIconFromResponse(cartResponse) {
    if (!cartResponse || !cartResponse.sections) return;
    if (cartResponse.sections['cart-icon-bubble']) {
      replaceSectionOnPage('cart-icon-bubble', cartResponse.sections['cart-icon-bubble']);
    }
    if (cartResponse.sections['cart-live-region-text']) {
      replaceSectionOnPage('cart-live-region-text', cartResponse.sections['cart-live-region-text']);
    }
    if (window.PUB_SUB_EVENTS && window.publish) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'skyyrizon-collection', cartData: cartResponse });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }
})();
